
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "FormTemplate",

  components: {},

  setup() {
    return {};
  },
});
